import React from "react";
import { StratifyDocument } from "@stratify/shared";
import { LogsList } from "./LogsList";
import { useDocumentLogs } from "../../hooks/useDocumentLogs";

interface LogsTabProps {
  document: StratifyDocument;
}

/**
 * Tab component that displays logs for a document
 * Uses useDocumentLogs hook to manage log subscription and state
 */
export const LogsTab: React.FC<LogsTabProps> = ({ document }) => {
  const { logs, loading, error } = useDocumentLogs(document.id);

  return <LogsList logs={logs} loading={loading} error={error} />;
};
